import { connect } from 'react-redux';
import { StoreState } from '../../reducers';

import Editor from '../../components/Editor';
import { PdfImportingStatus } from './constants';
import { getClientAndResourceIds } from './utils/helpers';
import Utils from '../../utils';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			type,
			previewPages,
			pagesController: { spreads, currentSpreadIndex },
			isEditorLoaded,
			combo: { isCombining },
			settings: { pdfImportingStatus },
			preprodPublication: { isUpdating },
		},
	} = state;
	const { clientId, tempGId, originalGId } = getClientAndResourceIds();
	const spread = spreads[currentSpreadIndex];
	const isPreviewPagesSpread = spread ? spread.some(page => previewPages.includes(page)) : false;

	const isAccessibleVersion = Utils.isAccessibleVersionMode();

	return {
		type,
		clientId,
		originalGId,
		tempGId,
		isEditorLoaded,
		isPreviewPagesSpread,
		isProcessing: isCombining ||
			pdfImportingStatus === PdfImportingStatus.PROCESSING ||
			isUpdating,
		isAccessibleVersion,
	};
};

export default connect(mapStateToProps)(Editor);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/index.tsx